import React, { useMemo } from "react";
import Knock from "@knocklabs/client";

function useAuthenticatedKnockClient(apiKey, userId, userToken) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var knockRef = React.useRef();
  return useMemo(() => {
    if (knockRef.current) knockRef.current.teardown();
    var knock = new Knock(apiKey, options);
    knock.authenticate(userId, userToken);
    knockRef.current = knock;
    return knock;
  }, [apiKey, userId, userToken]);
}

export default useAuthenticatedKnockClient;
//# sourceMappingURL=useAuthenticatedKnockClient.js.map